import { render } from "./ModalTags.vue?vue&type=template&id=5bce65ac&scoped=true"
import script from "./ModalTags.vue?vue&type=script&lang=js"
export * from "./ModalTags.vue?vue&type=script&lang=js"

import "./ModalTags.vue?vue&type=style&index=0&id=5bce65ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bce65ac"]])

export default __exports__